import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { FileText, Loader2, Copy } from "lucide-react";
import { toast } from "sonner";

export default function SharePage({ shareId }) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => { api.getShare(shareId).then(setData).catch(() => setError(true)); }, [shareId]);

  return (
    <div className="min-h-screen hq-grid">
      <header className="h-16 flex items-center px-5 border-b border-white/10">
        <div className="font-display font-black tracking-widest text-lg">LIFE<span className="text-cyan-400">//</span>OS</div>
        <span className="ml-3 text-[10px] uppercase tracking-[0.3em] text-zinc-500 font-mono">Shared Deliverable</span>
      </header>
      <div className="max-w-3xl mx-auto px-4 py-10">
        {error && <div className="text-center text-zinc-500 font-mono py-20">This shared link is invalid or was removed.</div>}
        {!data && !error && <div className="grid place-items-center py-20 text-cyan-300"><Loader2 className="animate-spin" size={26} /></div>}
        {data && (
          <div className="rounded-2xl border border-white/10 bg-[#080b11]/80 p-6">
            <div className="flex items-center gap-2 text-cyan-300 text-[11px] font-mono uppercase tracking-wider mb-2"><FileText size={14} /> Deliverable</div>
            <h1 className="font-display font-bold text-xl text-zinc-50 mb-1">{data.instruction}</h1>
            <div className="text-[11px] font-mono text-zinc-500 mb-5">Produced by {data.agent_name} · LifeOS agent</div>
            <div className="flex justify-end mb-1">
              <button onClick={() => { navigator.clipboard.writeText(data.deliverable); toast.success("Copied"); }} className="text-[11px] font-mono text-zinc-400 hover:text-cyan-300 flex items-center gap-1"><Copy size={12} /> Copy</button>
            </div>
            <pre className="text-sm leading-relaxed text-zinc-200 whitespace-pre-wrap font-sans bg-[#0b0e14] border border-white/10 rounded-xl p-4">{data.deliverable}</pre>
          </div>
        )}
      </div>
    </div>
  );
}
